<template>
  <nav class="navbar">
    <span class="navbar-toggle" @click="showMenu()">
      <i class="fas fa-bars"></i>
    </span>
    <a href="/" class="logo">
      <img alt="Travessia Online" src="../assets/logo-travessia.png" width="130px" height="40px">
    </a>
    <ul class="main-nav" :class="active ? 'active' : ''">
      <li>
        <a href="#comofunciona" @click="removeMenu" class="nav-links">Como funciona</a>
      </li>
      <li>
        <a href="#vantagens" @click="removeMenu" class="nav-links">Vantagens</a>
      </li>
      <li>
        <a href="#planos" @click="removeMenu" class="nav-links">Planos</a>
      </li>
      <li>
        <a href="#contato" @click="removeMenu" class="nav-links">Contato</a>
      </li>
      <!-- <li>
        <a href="/login-corretor" class="nav-links">Torne-se corretor</a>
      </li> -->
      <li v-if="!isLoggedIn">
        <a href="#" @click="showModalRegister()" class="nav-links">Cadastre-se</a>
      </li>
      <li v-if="!isLoggedIn">
        <a href="#" @click="showModalLogin()" class="nav-links">Login</a>
      </li>
      <li>
        <t-button v-if="isLoggedIn" class="nav-links nav-logout" to="dashboard">Acesse sua Conta</t-button>
      </li>
      <li>
        <t-button @click="logout()" v-if="isLoggedIn" class="nav-links nav-logout">Deslogar</t-button>
      </li>
    </ul>
    <modal
      width="320"
      height="auto"
      :scrollable="true"
      :clickToClose="true"
      transition="nice-modal-fade"
      :delay="150"
      name="login"
    >
      <t-close-modal modalName="login"></t-close-modal>
      <login-register :clickToClose="true" howComponent="login"/>
    </modal>
    <modal
      width="320"
      height="auto"
      :scrollable="true"
      transition="nice-modal-fade"
      :delay="150"
      name="register"
    >
      <t-close-modal modalName="register"></t-close-modal>
      <login-register :clickToClose="true" howComponent="register"/>
    </modal>
  </nav>
</template>

<script>
import LoginRegister from '@/domains/auth-student/container'
import TButton from '@/components/TButton.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Navbar',
  components: {
    LoginRegister,
    TButton
  },
  data: () => ({
    active: false,
    activeModal: false
  }),
  computed: {
    ...mapGetters('Login', ['isLoggedIn'])
  },
  methods: {
    removeMenu () {
      this.active = false
    },
    ...mapActions('Login', ['logout']),
    showMenu () {
      this.active = !this.active
    },
    showModalLogin () {
      this.active = false
      this.$modal.show('login')
    },
    showModalRegister () {
      this.active = false
      this.$modal.show('register')
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
body {
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif;
}
.navbar {
  font-size: 18px;
  background: #3377b8;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  padding-bottom: 10px;
  position:fixed;
  width: 100%;
  z-index: 9999;
}
.main-nav {
  list-style-type: none;
  display: none;
}
.nav-links,
.logo {
  text-decoration: none;
  color: white;
  display: inline-block;
  font-size: 20px;
  margin-top: 10px;
  margin-left: 20px;
}
.main-nav li {
  text-align: center;
  margin: 15px auto;
}
.navbar-toggle {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
  padding-top: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 24px;
}
.active {
  display: block;
}
@media screen and (max-width: 1200px) {
  .nav-links{
    font-size: 15px
  }
}

@media screen and (min-width: 768px) {
  .navbar {
    display: flex;
    justify-content: space-between;
    padding-bottom: 0;
    height: 70px;
    align-items: center;
  }
  .main-nav {
    display: flex;
    margin-right: 30px;
    flex-direction: row;
    justify-content: flex-end;
  }
  .main-nav li {
    margin: 0;
  }
  .nav-links {
    margin-left: 40px;
  }
  .logo {
    margin-top: 0;
  }
  .navbar-toggle {
    display: none;
  }
  .logo:hover,
  a.nav-links:hover {
    color: #ff6501;
  }
}
.nav-logout {
  margin-top: 0.3rem;
}
</style>
